@if (loading()) {
  <div class="container-fluid py-6 text-center text-muted">A carregar…</div>
} @else if (error()) {
  <div class="container-fluid py-6 text-center text-danger">{{ error() }}</div>
} @else if (organization(); as o) {
  <div class="container-fluid">
    <app-page-header
      icon="fe-briefcase"
      pretitle="Organização"
      [title]="o.name"
      [description]="clients().length + ' cliente(s) vinculado(s)'"
    >
      <div actions class="d-flex align-items-center gap-2">
        @if (auth.can('organization:write')) {
          <a class="btn btn-white" [routerLink]="['editar']"><i class="fe fe-edit-2 me-1"></i> Editar</a>
        }
        <a class="btn btn-outline-light" [routerLink]="['..']">Voltar</a>
      </div>
    </app-page-header>
  </div>

  <div class="container-fluid">
    <div class="row">
      <!-- Detalhes -->
      <div class="col-12 col-lg-4">
        <!-- Logo -->
        <div class="card">
          <div class="card-body text-center">
            <div class="avatar avatar-xxl mb-3">
              @if (o.logoUrl) {
                <img [src]="o.logoUrl" [alt]="o.name" class="avatar-img rounded" />
              } @else {
                <span class="avatar-title rounded org-detail-logo-fallback">{{ o.name.charAt(0).toUpperCase() }}</span>
              }
            </div>
            <div>
              <label class="btn btn-sm btn-white mb-0" [class.disabled]="uploading()">
                <i class="fe fe-upload me-1"></i>{{ o.logoUrl ? 'Trocar logo' : 'Enviar logo' }}
                <input
                  type="file"
                  class="d-none"
                  accept="image/png,image/jpeg,image/webp,image/gif,image/svg+xml"
                  [disabled]="uploading()"
                  (change)="onLogoSelected($event)"
                />
              </label>
            </div>
            @if (uploading()) {
              <p class="small text-muted mt-2 mb-0">Enviando…</p>
            }
            @if (uploadError()) {
              <p class="small text-danger mt-2 mb-0">{{ uploadError() }}</p>
            }
          </div>
        </div>

        <div class="card">
          <div class="card-header">
            <div class="d-flex align-items-center">
              <span class="avatar avatar-sm me-3"><span class="avatar-title fs-lg rounded bg-primary-soft text-primary"><i class="fe fe-info"></i></span></span>
              <h4 class="card-header-title mb-0">Detalhes</h4>
            </div>
          </div>
          <div class="card-body">
            <label class="form-label small text-muted">Domínios</label>
            <div class="mb-3">
              @if (o.domains.length) {
                @for (d of o.domains; track d) { <span class="badge bg-secondary-soft me-1">{{ d }}</span> }
              } @else {
                <span class="small text-muted">Nenhum domínio registado</span>
              }
            </div>

            <dl class="row small mb-0 gy-2">
              <dt class="col-4 text-muted">Criada</dt>
              <dd class="col-8 mb-0">{{ o.createdAt | date: 'dd/MM/yyyy HH:mm' }}</dd>
              @if (o.notes) {
                <dt class="col-4 text-muted">Notas</dt>
                <dd class="col-8 mb-0" style="white-space: pre-wrap;">{{ o.notes }}</dd>
              }
            </dl>
          </div>
        </div>
      </div>

      <!-- Clientes -->
      <div class="col-12 col-lg-8">
        <div class="card">
          <div class="card-header">
            <div class="d-flex align-items-center">
              <span class="avatar avatar-sm me-3"><span class="avatar-title fs-lg rounded bg-info-soft text-info"><i class="fe fe-users"></i></span></span>
              <h4 class="card-header-title mb-0">Clientes</h4>
            </div>
            <span class="badge bg-secondary-soft">{{ clients().length }}</span>
          </div>
          <div class="card-body p-0">
            @if (clients().length === 0) {
              <p class="text-muted text-center py-5 mb-0">Nenhum cliente vinculado a esta organização.</p>
            } @else {
              <div class="table-responsive">
                <table class="table table-hover table-nowrap card-table mb-0">
                  <thead>
                    <tr><th>Nome</th><th>E-mail</th><th>Situação</th></tr>
                  </thead>
                  <tbody>
                    @for (c of clients(); track c.id) {
                      <tr [routerLink]="['/', tenant(), 'clientes', c.id]" style="cursor: pointer;">
                        <td>{{ c.name }}</td>
                        <td><span class="small">{{ c.email }}</span></td>
                        <td><span class="badge" [class]="statusBadge(c.status)">{{ statusLabels[c.status] }}</span></td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}
